;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Model = APP.module('Model');
	const checkboxFieldTemplate = JST.Checkbox;

	Model.User = Backbone.Model.extend({
		initialize: function() {
			this.set('avatars_url', CONFIG.AVATARS_URL);
			this.listenTo(this, 'change:birthday', this.stripModelDate);
			// this.getUser();
		},
		stripModelDate() {

			return this;
		},
		localStorage: new Backbone.LocalStorage("User"),
		defaults: {
			first_name: '',
			last_name: '',
			email: '',
			password: '',
			team_name: '',
			gender: '',
			country: '',
			state: '',
			postcode: '',
			birthday: '',
			mobile: '',
			team_supported: '',
			skill_level: '',
			disable_notifications: 0,
			news: 0,
			weekly_results: 0,
			weekly_reminders: 0,
			facebook_id: '',
			twitter_id: '',
			recovered: '',
			id: '',
			avatar: '',
			avatar_url: ''
		},
		isNew: function(){
			return true;
		},

		// getUser() {
		// 	const sid = 'c7426f7b057275404af5c38540abb9f82ba60f7f';
		//
		// 	APP.setJStorage('session_id', sid);
		// 	$.ajaxQ.preventAbort();
		//
		// 	this.show_my().fetch().then(function(response) {
		// 		console.warn(response);
		//
		// 		$.ajaxQ.enableAbord();
		//
		// 	});
		// },

		login: function(){
			return this.setApiUrl( 'login' ).save(this.toJSON(), {ajaxSync: true});
		},

		preregistration: function(){
			return this.setApiUrl( 'preregistration' ).save(this.toJSON(), {ajaxSync: true});
		},

		logout: function() {
			return this.setApiUrl( 'logout' )
					.clear()
					.set(this.defaults)
					.fetch({type: 'POST', ajaxSync: true});
		},

		update: function(user_model) {
			this.set('cid', undefined);
			var form = this.prepareFormData(user_model);
			return this.setApiUrl( 'user/update' ).formAjaxCall(form);
		},

		create: function(data){
			var form = this.prepareFormData(data);
			return this.setApiUrl( 'user/create' ).formAjaxCall(form);
		},

		
		createSSO: function(data){
			var form = this.prepareFormData(data);
			return this.setApiUrl( 'afl_id/register' ).formAjaxCall(form);
		},

		show_my() {
			return this.setApiUrl( 'user/show_my' );
		},

		formAjaxCall: function(form){
			return $.ajax({
				url         : CONFIG.API_URL + this.methodUrl,
				data        : form,
				processData : false,
				contentType : false,
				type: 'POST',
				beforeSend: function(xhr, settings) {
					var getSid = APP.getJStorage('session_id') || '';
					settings.data.append('sid', getSid );
				}
			}).promise();
		},

		deactivate: function(){
			this.setApiUrl( 'user/deactivate' ).save(null, {
				ajaxSync: true,
				success: _.bind(function(model, resp) {
					if(resp.errors.length){
						this.trigger('deactivate:error', model, resp);
						alert(resp.errors[0].text)
					}else {
						this.trigger('deactivate:success', model, resp);
						APP.vent.trigger('user:logout');
					}
				},this)
			});
			return this;
		},

		getProfile: function(user){
			return this.setApiUrl( 'user/show_my_profile' ).save(null, {
				type: 'GET',
				ajaxSync: true,
				data: false,
				success: _.bind(function(model, response){
					var updated_data = _.extend(model.toJSON(), response.result);
					this.set(updated_data);
					this.save(updated_data);
				}, this)
			}, this);
		},

		checkEmail: function(data){
			var email = _.isObject(data) ? data.getValue('email') : data;
			return this.setApiUrl( 'user/check_email' ).sendToCheck({email: email});
		},

		checkUserCode: function(data){
			return this.setApiUrl( 'user/check_user_code' ).sendToCheck({
				user_code: data.getValue('user_code'),
				type: data.getValue('type')
			});
		},

		checkTeamName: function(data){
			return this.setApiUrl( 'user/check_team_name' ).sendToCheck({team_name: data.getValue('team_name')});
		},

		sendToCheck: function(data) {
			return this.fetch({
				type: 'GET',
				ajaxSync: true,
				data: data,
				error: false,
				success: _.bind(function(model, response) {
					if (response.errors.length) {
						this.trigger('backend:user:validation', response.errors[0]);
					}else {
						this.trigger('backend:user:validation:no_errors');
					}
				},this)
			},this);
		},

		prepareFormData: function(data){
			_.each(data, function(value, key){
				if(_.isBoolean(value)){
					data[key]  = + value;
				}

				if(value && typeof value.getMonth === 'function'){
					data[key] = this.getCustomDateISOString(value);
				}
			}, this);
			var formData = new FormData();
			_.each(data, function(value,key){
				if (value instanceof File) {
					formData.append( key, value );
					return;
				}
				formData.append(key, value);
			});
			return formData;
		},

		recoverUser: function(data){

			data = this.checkBoolean(data);
			return this.setApiUrl('user/recover').save({} , {data: data, ajaxSync: true});
		},

		register_for_game :function(data){
			data = this.checkBoolean(data);
			return this.setApiUrl('user/register_for_game').save({} , {data: data, ajaxSync: true});
		},

		checkBoolean: function(data){
			_.each(data, _.bind(function(value, key){

				if(_.isBoolean(value)){
					data[key]  = + value;
				}

				if(value && typeof value.getMonth === 'function'){
					data[key] = this.getCustomDateISOString(value);
				}

			}, this ));
			return data;
		},

		getCustomDateISOString : function(date) {
			var yyyy = date.getFullYear().toString();
			var mm   = (date.getMonth()+1).toString();
			var dd   = date.getDate().toString();
			return yyyy + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + (dd[1] ? dd : "0" + dd[0]);
		},

		checkLanguageForUser(){

			try{
				  let user_lang = this.get('user') && this.get('user')['lang'] || false,
					lang = i18next.language;

				if (user_lang && lang !== user_lang) {
					$.jStorage.set('user_lang', user_lang);
					i18next.changeLanguage(user_lang);
					window.location = window.location.pathname;
				}
			}catch (e){

			}

		},

		schema: {
			first_name:{
				title: 'First name:*',
				validators: [
					{
						type: 'regexp',
						field: 'first_name',
						regexp: /^[a-zA-Z\s]/,
						message: 'First name must contain only alpha characters.'
					}
				],
				editorAttrs: {
					maxlength: 45,
					placeholder: 'First Name:*'
				}
			},
			last_name:{
				title: 'Last name:*',
				validators: [
					{
						type: 'regexp',
						field: 'last_name',
						regexp: /^[a-zA-Z\s]/,
						message: 'Last name  must contain only alpha characters.'
					}
				],
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Last name:*'
				}
			},
			email:{
				title: 'Email:*',
				validators: ['email'],
				editorAttrs: {
					placeholder: 'Email:*',
					title: 'Your email will be used as your username when you log in'
				}
			},
			confirm_email:{
				validators: ['email',
					{
						type: 'match',
						field: 'email',
						message: 'Emails must match!'
					}
				],
				editorAttrs: {
					placeholder: 'Confirm Email:*'
				}
			},
			password:{
				type: 'Password',
				validators: [
					{
						type: 'regexp',
						field: 'password',
						regexp: /.{8,}/,
						message: 'Required password length is 8 symbols'
					}
				],
				editorAttrs: {
					minlength: 8,
					placeholder: 'Password:*'
				}
			},
			passwordConfirm:{
				type: 'Password',
				validators: [
					{
						type: 'regexp',
						field: 'password',
						regexp: /.{9,}/,
						message: 'Required password length is 9 symbols'
					},
					{
						type: 'match',
						field: 'password',
						message: 'Passwords must match!'
					}
				],
				editorAttrs: {
					placeholder: 'Password Confirm:*'
				}
			},
			mobile:{
				title: 'Mobile Number:*',
				validators: ['number'],
				editorAttrs: {
					minlength: 9,
					maxlength: 15,
					placeholder: 'Mobile Number:*'
				}
			},
			team_name:{
				title: 'Team name:*',
				validators: [/^[a-zA-Z0-9 ]/],
				editorAttrs: {
					maxlength: 40,
					placeholder: 'Team name:*'
				}
			},
			
			disable_notifications: {
				type: 'CheckboxCustom',
				title: 'I agree to receiving direct communications',
				options:{},
				editorAttrs: {
					maxlength: 40,
					title: 'Tooltip help'
				},
				template: checkboxFieldTemplate
			},
			avatar: {
				type: "ImagePicker",
				template: JST.ImageUploader,
				options:{
					button_text: 'asdasdsa'
				}
			}
		}
	});

}(window, APP, Backbone, Marionette, $, _));